(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 27646:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(87353);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ numberCheck; }
/* harmony export */ });
var numberCheck = function(value) {
    return /^[1-9]\d*$/.test(value);
};


/***/ }),

/***/ 86782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _common_NumberCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55262);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: #7e7e7e;\n  font-size: 14px;\n  font-weight: 400;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



 // numberCheck 함수 import

var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-29b482a1-0"
})(_templateObject());
var Breadcrumb2 = function(param) {
    var categoryName = param.categoryName, categoryHash = param.categoryHash, hash = param.hash, ename = param.ename;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // 해시가 숫자인지 확인 (페이지 번호인 경우)
    var isNumericHash = hash && (0,_common_NumberCheck__WEBPACK_IMPORTED_MODULE_4__/* .numberCheck */ .M)(hash);
    var isNumericRouterHash = router.query.hash && (0,_common_NumberCheck__WEBPACK_IMPORTED_MODULE_4__/* .numberCheck */ .M)(router.query.hash);
    // 표시할 해시 결정 (숫자인 경우 표시하지 않음)
    var displayHash = isNumericHash ? null : hash;
    var displayRouterHash = isNumericRouterHash ? null : router.query.hash;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: categoryHash && categoryName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "page-header mb-30",
            style: {
                wordBreak: "keep-all"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "mb-15 text-capitalize",
                            children: categoryName
                        }),
                        !router.query.search && !router.query.garo && !router.query.sero && !router.query.high && !router.query.erange && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "breadcrumb",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        rel: "nofollow",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fi-rs-home mr-5"
                                            }),
                                            "\uD648"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                    href: "/products/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        children: "\uC0C1\uD488\uAD6C\uB9E4"
                                    })
                                }),
                                hash ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                            href: "/products/".concat(ename, "/"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                children: categoryName
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                        categoryName
                                    ]
                                }),
                                (displayHash || displayRouterHash) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                        displayHash || displayRouterHash
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumb2);


/***/ }),

/***/ 87353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/ecommerce/singleProduct/SingleProduct.js
var SingleProduct = __webpack_require__(57416);
// EXTERNAL MODULE: ./components/layout/Breadcrumb2.js
var Breadcrumb2 = __webpack_require__(86782);
// EXTERNAL MODULE: ./components/products/list/TableTypeList.js
var TableTypeList = __webpack_require__(17461);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/search/Search.styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 50px 0;\n  .p_title {\n    width: 100%;\n    margin-bottom: 30px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    & div {\n      margin-bottom: 0px !important;\n    }\n    @media screen and (max-width: 1199px) {\n      display: none;\n    }\n  }\n  .m_title {\n    display: none;\n    @media screen and (max-width: 1199px) {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  & span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 10px;\n    border: 1px solid #ececec;\n    cursor: pointer;\n  }\n\n  .selected {\n    background-color: #3bb77e;\n    color: white;\n    border: 1px solid #3bb77e;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  .cnt {\n    font-size: 16px;\n  }\n  .filter {\n    width: fit-content;\n  }\n\n  @media (max-width: 991px) {\n    display: flex;\n    flex-direction: column;\n    .cnt {\n      width: 100%;\n      margin-bottom: 10px;\n    }\n    .filter {\n      width: 100%;\n    }\n  }\n  @media (max-width: 767px) {\n    & span {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 50px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border-bottom: 1px solid #ececec;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 20px;\n  margin-bottom: 20px;\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  word-break: keep-all;\n  margin-top: 50px;\n  margin-bottom: 30px;\n  & h4 {\n    margin-bottom: 20px;\n    text-align: center;\n  }\n  @media (max-width: 991px) {\n    & h4 {\n      font-size: 18px;\n    }\n    & a {\n      font-size: 14px;\n    }\n  }\n  @media (max-width: 767px) {\n    & h4 {\n      font-size: 16px;\n    }\n    & a {\n      padding: 5px 20px;\n      font-size: 12px;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  color: #253d4e;\n  .header {\n    background-color: #f9f6f6ba;\n  }\n  & tr {\n    text-align: center;\n    :hover {\n      background-color: #f9f6f6ba;\n    }\n  }\n\n  & th {\n    padding: 5px;\n    font-size: 14px;\n    word-break: keep-all;\n  }\n\n  & td {\n    padding: 10px;\n  }\n\n  & a {\n    color: #253d4e;\n  }\n\n  .img {\n    width: 10%;\n    padding: 5px;\n    & a {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n  .name {\n    width: 15%;\n    & a {\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      white-space: pre-wrap;\n      text-overflow: ellipsis;\n      word-break: keep-all;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n\n  .price {\n    color: #dc3545;\n  }\n\n  .btnWrapper {\n    width: 15%;\n  }\n\n  @media (max-width: 991px) {\n    & td {\n      padding: 5px;\n    }\n    .name {\n    }\n    .golgi {\n      width: 7%;\n    }\n    .feature {\n      width: 15%;\n    }\n    .sizes {\n      width: 10%;\n    }\n    .onePrice {\n      width: 10%;\n    }\n    .quantity {\n      width: 10%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 767px) {\n    & th {\n      font-size: 12px;\n    }\n    & td {\n      font-size: 12px;\n    }\n    .img {\n      display: none;\n    }\n    .golgi {\n      width: 7%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 575px) {\n    & th {\n      font-size: 10px;\n    }\n    & td {\n      font-size: 10px;\n      padding: 5px;\n    }\n    .name {\n      width: 25%;\n    }\n    .sizes {\n      display: none;\n    }\n    .strength {\n      width: 10%;\n    }\n    .feature {\n      width: 10%;\n    }\n    .golgi {\n    }\n    .onePrice {\n    }\n    .quantity {\n    }\n    .price {\n    }\n  }\n  @media (max-width: 460px) {\n    .quantity {\n      display: none;\n    }\n    .onePrice {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  word-break: keep-all;\n  @media (max-width: 991px) {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n  @media (max-width: 767px) {\n    font-size: 10px;\n  }\n  @media (max-width: 575px) {\n    font-size: 8px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #fd7e14;\n  color: #fff;\n  border: 1px solid #fd7e14;\n  margin-bottom: 2px;\n  :hover {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  border: 1px solid #3bb77e;\n  :hover {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0;\n\n  & > div {\n    & span {\n      text-decoration: line-through;\n      color: #6c757d;\n      opacity: 0.5;\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 20px;\n  margin-bottom: 20px;\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  cursor: pointer;\n  border: 1px solid #ececec;\n  border-radius: 10px;\n  padding-bottom: 20px;\n  overflow: hidden;\n  transition: 0.2s;\n  -moz-transition: 0.2s;\n  -webkit-transition: 0.2s;\n  -o-transition: 0.2s;\n\n  .thumbnail {\n    width: 100%;\n    margin-bottom: 10px;\n    & img {\n      max-width: 100%;\n      height: auto;\n    }\n  }\n\n  .title {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 50px;\n    & h5 {\n      font-size: 20px;\n      word-break: keep-all;\n      margin-bottom: 10px;\n      padding: 0px 10px;\n      transition: 0.2s;\n      -moz-transition: 0.2s;\n      -webkit-transition: 0.2s;\n      -o-transition: 0.2s;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: wrap;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      align-items: center;\n    }\n    @media (max-width: 991px) {\n      & h5 {\n        font-size: 16px;\n      }\n      height: 40px;\n    }\n    @media (max-width: 460px) {\n      & h5 {\n        font-size: 14px;\n      }\n      height: 34px;\n    }\n  }\n\n  .sub_title {\n    color: #7e7e7e;\n    padding: 0px 20px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    @media (max-width: 991px) {\n      font-size: 16px;\n    }\n    @media (max-width: 460px) {\n      font-size: 12px;\n    }\n  }\n\n  :hover {\n    border-color: #3bb77e;\n    transition: 0.2s;\n    -moz-transition: 0.2s;\n    -webkit-transition: 0.2s;\n    -o-transition: 0.2s;\n    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    .title {\n      color: #3bb77e;\n      transition: 0.2s;\n      -moz-transition: 0.2s;\n      -webkit-transition: 0.2s;\n      -o-transition: 0.2s;\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n  cursor: pointer;\n  background-color: #3bb77e;\n  padding: 10px 20px;\n  border-radius: 10px;\n  margin: auto;\n  color: #fff;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-32fd2a7b-0"
})(_templateObject());
var ListViewTypeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-1"
})(_templateObject1());
var ListViewSelectBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-2"
})(_templateObject2());
var FilterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-3"
})(_templateObject3());
var ListWraper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-4"
})(_templateObject4());
var CategoryTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-32fd2a7b-5"
})(_templateObject5());
var ProductsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-6"
})(_templateObject6());
var ProductsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-7"
})(_templateObject7());
var ProductsSignWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-8"
})(_templateObject8());
// table type list
var TableTypeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-9"
})(_templateObject9());
var Table = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-32fd2a7b-10"
})(_templateObject10());
var BtnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-11"
})(_templateObject11());
var CheckoutBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-32fd2a7b-12"
})(_templateObject12());
var CartBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-32fd2a7b-13"
})(_templateObject13(), function(props) {
    return props.inCart ? "#3bb77e" : "#fff";
}, function(props) {
    return props.inCart ? "#fff" : "#3bb77e";
});
var PriceBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-14"
})(_templateObject14());
var SearchedCommunity = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-15"
})(_templateObject15());
var CommunityBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-16"
})(_templateObject16());
var MoreBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-32fd2a7b-17"
})(_templateObject17());

// EXTERNAL MODULE: ./components/filterList/FilterList.js + 3 modules
var FilterList = __webpack_require__(85830);
;// CONCATENATED MODULE: ./components/search/Search.presenter.js








var SearchUI = function(param) {
    var router = param.router, viewType = param.viewType, handleListViewType = param.handleListViewType, searchList = param.searchList, searchTerm = param.searchTerm, dummyList = param.dummyList, purchaseDirect = param.purchaseDirect, searchedTotal = param.searchedTotal, moveToDetail = param.moveToDetail, moreProducts = param.moreProducts, cateViewStats = param.cateViewStats;
    var ref11, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var sizeTxt = "".concat(((ref11 = router.query) === null || ref11 === void 0 ? void 0 : ref11.garo) > 0 ? "\uAC00\uB85C ".concat(router.query.garo, " ") : "") + "".concat(((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.sero) > 0 ? "\uC138\uB85C ".concat(router.query.sero, " ") : "") + "".concat(((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.high) > 0 ? "\uB192\uC774 ".concat(router.query.high, " ") : "") + "".concat(((ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.erange) > 0 ? "\uC624\uCC28\uBC94\uC704 ".concat(router.query.erange) : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "m_title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb2/* default */.Z, {
                            categoryName: router.query ? "".concat(router.query.search && "'".concat(router.query.search, "'")) + (router.query.search && sizeTxt && ", ") + "(\uC73C)\uB85C \uAC80\uC0C9\uD55C \uACB0\uACFC" : "",
                            categoryHash: "",
                            hash: router.query.hash
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb2/* default */.Z, {
                                categoryName: router.query ? "".concat(router.query.search && "'".concat(router.query.search, "'")) + (router.query.search && sizeTxt && ", ") + sizeTxt + "(\uC73C)\uB85C \uAC80\uC0C9\uD55C \uACB0\uACFC" : "",
                                categoryHash: router.query.search + sizeTxt,
                                productFilters: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterWrapper, {
                                className: "",
                                children: searchedTotal > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "cnt",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: "text-brand",
                                            children: searchedTotal
                                        }),
                                        "\uAC1C\uC758 \uC0C1\uD488"
                                    ]
                                })
                            }),
                            router.query && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid, {
                                        className: "",
                                        children: searchList.data && Object.keys(searchList.data).length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductsSignWrapper, {
                                            style: {
                                                gridColumn: "span 4"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "\uCC3E\uC73C\uC2DC\uB294 \uC0C1\uD488\uC774 \uC5C6\uB2E4\uBA74 \uC6B0\uCE21 \uD558\uB2E8\uC758 \uCC44\uB110\uD1A1\uC73C\uB85C \uBB38\uC758\uB97C \uB123\uC5B4\uC8FC\uC2DC\uAC70\uB098"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "\uB9DE\uCDA4\uC81C\uC791 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD574\uBCF4\uC138\uC694."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "btn",
                                                    href: "/customizing/customizing-products/",
                                                    children: "\uB9DE\uCDA4\uC81C\uC791 \uBC14\uB85C\uAC00\uAE30"
                                                })
                                            ]
                                        })
                                    }),
                                    (searchList === null || searchList === void 0 ? void 0 : searchList.data) && Object.keys(searchList.data).length > 0 && Object.keys(searchList.data).map(function(key, i) {
                                        var ref, ref9, ref10;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ListWraper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTitle, {
                                                    children: key
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid, {
                                                    children: searchList.data && searchList.data[key].slice(((ref = cateViewStats[key]) === null || ref === void 0 ? void 0 : ref.start) || 0, ((ref9 = cateViewStats[key]) === null || ref9 === void 0 ? void 0 : ref9.last) || 8).map(function(item, itemIdx) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct/* default */.Z, {
                                                            product: item,
                                                            dummyList: dummyList,
                                                            listViewType: viewType ? viewType : "grid"
                                                        }, itemIdx);
                                                    })
                                                }),
                                                ((ref10 = cateViewStats[key]) === null || ref10 === void 0 ? void 0 : ref10.last) <= searchList.data[key].length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MoreBtn, {
                                                    onClick: function() {
                                                        return moreProducts(key);
                                                    },
                                                    children: [
                                                        "\uAC80\uC0C9\uB41C ",
                                                        key,
                                                        " \uB354\uBCF4\uAE30"
                                                    ]
                                                })
                                            ]
                                        }, i);
                                    }),
                                    (searchList === null || searchList === void 0 ? void 0 : (ref4 = searchList.community) === null || ref4 === void 0 ? void 0 : ref4.data) && ((ref5 = searchList.community) === null || ref5 === void 0 ? void 0 : ref5.data.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListWraper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTitle, {
                                                children: "\uAD00\uB828 \uAC8C\uC2DC\uBB3C"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchedCommunity, {
                                                children: searchList.community.data.slice(((ref6 = cateViewStats.community) === null || ref6 === void 0 ? void 0 : ref6.start) || 0, ((ref7 = cateViewStats.community) === null || ref7 === void 0 ? void 0 : ref7.last) || 8).map(function(el, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommunityBox, {
                                                        onClick: function() {
                                                            return moveToDetail(el.id);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "thumbnail",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: el.thumbnail
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "title",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                    children: el.title
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                className: "sub_title",
                                                                children: el.sub_title
                                                            })
                                                        ]
                                                    }, i);
                                                })
                                            }),
                                            (cateViewStats === null || cateViewStats === void 0 ? void 0 : (ref8 = cateViewStats.community) === null || ref8 === void 0 ? void 0 : ref8.last) <= searchList.community.data.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreBtn, {
                                                onClick: function() {
                                                    return moreProducts("community");
                                                },
                                                children: "\uAC80\uC0C9\uB41C \uAC8C\uC2DC\uBB3C \uB354\uBCF4\uAE30"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Search_presenter = (SearchUI);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
// EXTERNAL MODULE: ./common/modalOverflowHook.js
var modalOverflowHook = __webpack_require__(39277);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
;// CONCATENATED MODULE: ./pages/search/index.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var SearchPage = function(param) {
    var _$isLoaded = param.isLoaded, _$isLoading = param.isLoading, dummyList = param.dummyList, loading = param.loading;
    var router = (0,next_router.useRouter)();
    var searchTerm = router.query.search;
    // 리스트 타입
    var ref6 = (0,react.useState)("grid"), viewType = ref6[0], setViewType = ref6[1];
    // 검색 리스트
    var ref1 = (0,react.useState)({}), searchList = ref1[0], setSearchList = ref1[1];
    // total
    var ref2 = (0,react.useState)(0), searchedTotal = ref2[0], setSearchedTotal = ref2[1];
    // 로그인 모달
    var ref3 = (0,react.useState)(false), openLoginModal = ref3[0], setOpenLoginModal = ref3[1];
    var modalScollHook = (0,modalOverflowHook/* default */.Z)(openLoginModal);
    var ref4 = (0,react.useState)({
        community: {
            start: 0,
            last: 8
        }
    }), cateViewStats = ref4[0], setCateViewStats = ref4[1];
    var ref5 = (0,react.useState)(false), searchLoading = ref5[0], setSearchLoading = ref5[1];
    var moreProducts = function(key) {
        var ref;
        setCateViewStats(_objectSpread({}, cateViewStats, _defineProperty({}, key, {
            start: 0,
            last: ((ref = cateViewStats[key]) === null || ref === void 0 ? void 0 : ref.last) + 8
        })));
    };
    // 비회원 바로 구매 모달 오픈
    var handleLoginModal = function() {
        setOpenLoginModal(function(prev) {
            return !prev;
        });
    };
    // 바로 구매하기
    var purchaseDirect = function(product) {
        return function() {
            sessionStorage.setItem("directOrder", JSON.stringify([
                _objectSpread({}, product, {
                    cnt: 1
                })
            ]));
            if (!getCookie("token") && !openLoginModal) {
                handleLoginModal();
                return;
            } else {
                document.body.style.removeProperty("overflow");
                sessionStorage.setItem("directOrder", JSON.stringify([
                    _objectSpread({}, product, {
                        cnt: 1
                    })
                ]));
                router.push({
                    pathname: "/checkout",
                    query: {
                        type: "direct"
                    }
                });
            }
        };
    };
    var handleListViewType = function(type) {
        if (viewType === type) {
            return;
        }
        localStorage.setItem("P_viewType", type);
        setViewType(type);
    };
    var fetchSearchedProducts = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSearchLoading(true);
                        setSearchList({});
                        setSearchedTotal(null);
                        body = _objectSpread({
                            modes: "Search"
                        }, router.query, {
                            searchTxt: router.query.search
                        });
                        _ctx.next = 6;
                        return (0,products/* searchProducts */.s3)(body);
                    case 6:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            setSearchList(res.Data.Rows);
                            setSearchedTotal(res.Data.Rows.total_count);
                        } else {
                            setSearchList({
                                data: [],
                                total_count: 0
                            });
                        }
                        setSearchLoading(false);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchSearchedProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    var moveToDetail = function(id) {
        window.open("/esg-guide/post/".concat(id));
    };
    (0,react.useEffect)(function() {
        var ref, ref7, ref8, ref9;
        if (!router.isReady) return;
        if (localStorage.getItem("P_viewType")) {
            setViewType(localStorage.getItem("P_viewType"));
        }
        if (((ref = router.query) === null || ref === void 0 ? void 0 : ref.search) || ((ref7 = router.query) === null || ref7 === void 0 ? void 0 : ref7.garo) || ((ref8 = router.query) === null || ref8 === void 0 ? void 0 : ref8.sero) || ((ref9 = router.query) === null || ref9 === void 0 ? void 0 : ref9.high)) {
            fetchSearchedProducts();
        }
    }, [
        router.query,
        router.isReady
    ]);
    (0,react.useEffect)(function() {
        if (searchList.data) {
            if (Object.keys(searchList.data).length > 0) {
                var keys = _toConsumableArray(Object.keys(searchList.data));
                var temp = _objectSpread({}, cateViewStats);
                if (keys.length > 0) {
                    keys.forEach(function(key) {
                        temp = _objectSpread({}, temp, _defineProperty({}, key, {
                            start: 0,
                            last: 8
                        }));
                    });
                }
                setCateViewStats(temp);
            }
            setSearchLoading(false);
        }
    }, [
        searchList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: "/search"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                noBreadcrumb: "d-none",
                children: [
                    searchLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex align-items-center justify-content-center",
                            style: {
                                minHeight: "500px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                animation: "border",
                                role: "status"
                            })
                        })
                    }),
                    (searchList === null || searchList === void 0 ? void 0 : searchList.data) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_presenter, {
                        router: router,
                        viewType: viewType,
                        handleListViewType: handleListViewType,
                        searchList: searchList,
                        searchTerm: searchTerm,
                        dummyList: dummyList,
                        purchaseDirect: purchaseDirect,
                        searchedTotal: searchedTotal,
                        moveToDetail: moveToDetail,
                        moreProducts: moreProducts,
                        cateViewStats: cateViewStats
                    })
                ]
            }),
            openLoginModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestLoginModal, {
                handleLoginModal: handleLoginModal,
                openLoginModal: openLoginModal,
                purchaseDirect: purchaseDirect,
                product: JSON.parse(sessionStorage.getItem("directOrder"))[0],
                cnt: 1
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList,
        loading: state.loading
    };
};
var mapDidpatchToProps = {
    isLoaded: loading/* isLoaded */.k,
    isLoading: loading/* isLoading */.h
};
/* harmony default export */ var search = ((0,es/* connect */.$j)(mapStateToProps, mapDidpatchToProps)(SearchPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,2511,4948,1111,5830,9774,2888,179], function() { return __webpack_exec__(27646); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);